module.exports = __webpack_public_path__ + "static/media/fase3.5dd27900.jpg";